import { DatabaseMigrator } from "../../migrator";
import { initDatabase } from "./1_initDatabase";
import { makeDataPersistentForMultipleUsers } from "./2_makeDataPersistentForMultipleUsers";

export const USER_DATABASE_VERSION = 2;

export const userDatabaseMigrator = new DatabaseMigrator([
	[1, initDatabase],
	[2, makeDataPersistentForMultipleUsers]
]);